/** R56: one amount of the server's order summary. */
export interface OrderAmount {
    net: number;
    vat: number;
    gross: number;
}

/** R56: one VAT line per tax group (a-e = Gruppe 1-5) of the order total. */
export interface OrderVatLine {
    vatPercent: number;
    taxGroup: number | null;
    taxGroupLetter: string | null;
    netAmount: number;
    vatAmount: number;
}

export type ShippingSummaryMode = 'NOT_REQUIRED' | 'NONE' | 'FROM' | 'EXACT';

/** R56-2: the cart/checkout figures the server computes over the order's calculated lines. */
export interface OrderSummary {
    listSum: OrderAmount;
    discount: OrderAmount;
    ownCommission: OrderAmount;
    orderValue: OrderAmount;
    subtotal: OrderAmount;
    shippingMode: ShippingSummaryMode;
    shipping: OrderAmount;
    shippingTaxGroup: number | null;
    shippingTaxGroupLetter: string | null;
    shippingVatPercent: number;
    credit: OrderAmount;
    cartTotal: OrderAmount;
    total: OrderAmount;
    vatLines: OrderVatLine[];
}

export const amountIn = (amount: OrderAmount, gross: boolean): number => (gross ? amount.gross : amount.net);

/** "C" for tax group 3 — the letter after a rate or amount, uppercase as the Product Manager writes it. */
export const taxGroupLabel = (letter: string | null | undefined): string | null =>
    letter ? letter.toUpperCase() : null;
